<template>
  <div class="reciept-box">
    <div class="recipient-imgs">
      <img
        src="/assets/faces Kreis.png"
        alt="recipient"
        class="recipient recipient-1"
      />
    </div>
    <div class="reciept-text-div">
      <div class="reciept-text-number font-roc-grotesk-bold">20.000+</div>
      <div class="reciept-text font-roc-grotesk-medium">
        Rezepturen erstellt
      </div>
    </div>
  </div>
</template>

<script></script>

<style scoped>
.reciept-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: beige;
  border-radius: 30px;
  width: 55%;
  height: 35px;
  margin-bottom: 20px;
  margin-top: 20px;
  gap: 10px;
  min-width: 300px;
}

.reciept-text-number {
  margin-right: 5px;
}

.reciept-text-div {
  display: flex;
  flex-direction: row;
  align-items: start;
  margin-top: 3px;
}

.recipient-imgs {
  display: flex;
  flex-direction: row;
  align-items: start;
}

.recipient {
  width: 45px;
}
</style>
